var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inviteselect"
  }, [_c('im-top'), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.entranceList), function(item, index) {
    return _c('p', {
      key: index
    }, [_c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.setEntrance(item.id)
        }
      }
    }, [_vm._v(_vm._s(item.name))])])
  })], 2)], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": require("../../assets/workorder/all.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v("请选择你要咨询的问题类型")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-630a3d46","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/im/inviteselect.vue
// module id = LVwr
// module chunks = 1